import { ExtraHoursRangeFragment } from 'generated/resources/graphql'

import { convertBackendMinutesToHours } from 'modules/attendance/components/SettingItemPage/TimeTracking/WorkTimeCategories/Content/utils/extraHoursUtils'
import { ExtraHoursRulesData } from 'modules/attendance/lib/forms/utils/ExtraHourRulesWizardData'
import ExtraHoursRangeUtils from 'modules/attendance/lib/utils/ExtraHoursRangeUtils'

export const isRangeOverlapping = (
  extraHoursRanges: ExtraHoursRangeFragment[],
  data: ExtraHoursRulesData
) => {
  if (!extraHoursRanges.length) return false

  return ExtraHoursRangeUtils.customExtraHoursRanges(extraHoursRanges).some((existingRange) => {
    const { id, fromMinute, toMinute } = existingRange
    if (data?.id && id === data.id) return false

    const { fromHour: existingRangeFromHour, toHour: existingRangeToHour } =
      convertBackendMinutesToHours(fromMinute, toMinute)
    const { fromHour: newRangeFromHour, toHour: newRangeToHour } = data

    const isNewRangeUnlimited = data.isUnlimited()
    const isExistingRangeUnlimited = ExtraHoursRangeUtils.isUnlimited(existingRange)

    const newRangeStartsBeforeExistingRangeEnds =
      newRangeFromHour <= (existingRangeToHour ?? Infinity)
    const newRangeEndsAfterExistingRangeStarts =
      (newRangeToHour ?? Infinity) >= existingRangeFromHour

    if (isNewRangeUnlimited) {
      return isExistingRangeUnlimited || newRangeStartsBeforeExistingRangeEnds
    } else {
      return (
        (isExistingRangeUnlimited && newRangeEndsAfterExistingRangeStarts) ||
        (newRangeStartsBeforeExistingRangeEnds && newRangeEndsAfterExistingRangeStarts)
      )
    }
  })
}
